import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { CollapseModule } from 'ngx-bootstrap/collapse';

import { NgProgressModule } from "ngx-progressbar";
import { AppComponent } from "./app.component";
import { AppRoutingModule } from "./app.routing";

import { CommonModule } from "@angular/common";
import { AngularFireModule } from "@angular/fire";
import { AngularFireDatabaseModule } from "@angular/fire/database";
import { AngularFirestore } from "@angular/fire/firestore";
import { NgSelectModule } from "@ng-select/ng-select";
import { Ng2SmartTableModule } from "ng2-smart-table";
import { ModalModule } from "ngx-bootstrap";
import { MomentModule } from "ngx-moment";
import { LocalStorageModule } from "../../node_modules/angular-2-local-storage";
import { environment } from "../environments/environment";
import { BuilkModule } from "./components/builk/builk.module";
import { HomeComponent } from "./components/home/home.component";
import { JubiliModule } from "./components/jubili/jubili.module";
import { LoaderComponent } from "./components/loader/loader.component";
import { AddRoleModalComponent } from "./components/role-manager/add-role-modal/add-role-modal.component";
import { EditRoleModalComponent } from "./components/role-manager/edit-role-modal/edit-role-modal.component";
import { RoleManagerComponent } from "./components/role-manager/role-manager.component";
import { RoleOperationComponent } from "./components/role-manager/role-operation/role-operation.component";
import { LoginComponent } from "./components/security/login/login.component";
import { SharedModule } from "./components/shared/shared.module";
import { PipeModule } from "./pipe/pipe.module";
import { AuthGuard } from "./service/components/authentication/guards/auth.guard";
import { InterceptorService } from "./service/components/authentication/interceptor.service";
import { AngularFireAuthModule } from "@angular/fire/auth";
import { LoadingModule } from "ngx-loading";
import { DesignSystemModule } from "./components/design-system/design-system.module";

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    HomeComponent,
    LoaderComponent,
    RoleManagerComponent,
    AddRoleModalComponent,
    EditRoleModalComponent,
    RoleOperationComponent
  ],
  exports: [
    LoaderComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: "ng-cli-universal" }),
    HttpClientModule,
    FormsModule,
    PipeModule,
    AppRoutingModule,
    NgProgressModule,
    LocalStorageModule.withConfig({
      prefix: "jubili",
      storageType: "localStorage"
    }),
    SharedModule,
    JubiliModule,
    BuilkModule,
    DesignSystemModule,
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFireDatabaseModule,
    PipeModule,
    Ng2SmartTableModule,
    CommonModule,
    MomentModule,
    ModalModule.forRoot(),
    NgSelectModule,
    ReactiveFormsModule,
    AngularFireAuthModule,
    LoadingModule,
    CollapseModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptorService,
      multi: true
    },
    AuthGuard,
    AngularFirestore,
    PipeModule
  ],
  bootstrap: [AppComponent],
  entryComponents: [RoleOperationComponent]
})
export class AppModule { }
